import React from "react";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { useLocation } from "react-router-dom";

const PageLayout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div>
      {!isLoginPage && <NavBar />}
      <div className="">{children}</div>
      {!isLoginPage && <Footer />}
    </div>
  );
};

export default PageLayout;